import { render } from "./UploadFile.vue?vue&type=template&id=be0cf1c2"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=be0cf1c2&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__